// extracted by mini-css-extract-plugin
module.exports = {"PlumContainer":"Plum_PlumContainer__d65Ym","PlumValue":"Plum_PlumValue__VoLNX","IconWrapper":"Plum_IconWrapper__2yZe6"};